'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('piperListEdit', {
      url: '/piper/:type/list/edit/:id',
      template: '<piper-list-edit></piper-list-edit>'
    });
}



// WEBPACK FOOTER //
// ./client/app/piper/list/edit/list-edit.routes.js